var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"carat",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"13","height":"7","viewBox":"0 0 13 7"},on:{"click":_vm.svgClick}},[_c('path',{attrs:{"fill":"none","fill-rule":"evenodd","stroke":"#54392D","stroke-linecap":"round","stroke-width":"1.5","d":"M.82 1.1l5.366 4.887 5.335-4.92"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }